"use strict";
const IDENTITY_CLAIMS = ["username", "email", "sub"];
export const getAnalyticsIdFromAuthToken = (authToken) => {
  try {
    const [, payloadSegment] = authToken.split(".");
    const base64Payload = payloadSegment.replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(atob(base64Payload));
    for (const claim of IDENTITY_CLAIMS) {
      const value = payload[claim];
      if (typeof value === "string" && value.trim() !== "") return value;
    }
    return null;
  } catch {
    return null;
  }
};
